<template>
    <nav v-if="breadcrumbs" class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center">
            <!-- В мобильной версии показываем только предыдущую страницу -->
            <OnlyMobile>
                <li v-if="previousBreadcrumb" class="inline-flex items-center">
                    <div class="flex items-center">
                        <IconAngleLeftFilled class="w-6 h-6"
                                             :class="[themeStore.theme === themeStore.themeTypes.light ? 'text-gray-700' : 'text-white']"/>
                        <Link :href="previousBreadcrumb.url"
                              class="inline-flex items-center text-sm font-medium hover:text-indigo-600"
                              :class="[themeStore.theme === themeStore.themeTypes.light ? 'text-gray-700' : 'text-white']">
                            {{ previousBreadcrumb.title }}
                        </Link>
                    </div>
                </li>
            </OnlyMobile>

            <!-- В десктопной версии показываем все страницы -->
            <OnlyDesktop>
                <li v-for="(breadcrumb, key) in breadcrumbs" :key="key" class="inline-flex items-center">
                    <div class="flex items-center">
                        <IconAngleLeft v-if="key !== 0" class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <Link v-if="key !== breadcrumbs.length - 1" :href="breadcrumb.url"
                              class="inline-flex items-center text-xs font-bold hover:text-indigo-600 cursor-pointer"
                              :class="[themeStore.theme === themeStore.themeTypes.light ? 'text-gray-700' : 'text-white']">
                            {{ breadcrumb.title }}
                        </Link>
                        <span v-else class="inline-flex items-center text-xs font-bold cursor-default"
                              :class="[themeStore.theme === themeStore.themeTypes.light ? 'text-gray-700' : 'text-white']">
                            {{ breadcrumb.title }}
                        </span>
                    </div>
                </li>
            </OnlyDesktop>
        </ol>
    </nav>
</template>

<script>
import {Link, usePage} from "@inertiajs/vue3";
import {useThemeStore} from "@js/store/ThemeStore.js";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import IconAngleLeftFilled from "@js/components/Icons/IconAngleLeftFilled.vue";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";

export default {
    name: "Breadcrumbs",
    components: {IconAngleLeft, IconAngleLeftFilled, OnlyDesktop, OnlyMobile, Link},
    props: {
        color: {
            type: String,
            default: "#201f1d",
        },
    },
    data() {
        return {
            breadcrumbs: null,
        };
    },
    computed: {
        previousBreadcrumb() {
            // Возвращаем предпоследний элемент
            if (this.breadcrumbs && this.breadcrumbs.length > 1) {
                return this.breadcrumbs[this.breadcrumbs.length - 2];
            }
            return null;
        },
    },
    methods: {
        insertSchemaMarkup() {
            if (typeof window !== "undefined") {
                const scriptId = "schema-breadcrumbs-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": this.breadcrumbs.map((breadcrumb, index) => ({
                        "@type": "ListItem",
                        "position": index + 1,
                        "name": breadcrumb.title,
                        "item": breadcrumb.url
                    }))
                })

                document.head.appendChild(script);
            }
        },
        removeSchemaMarkup() {
            const script = document.getElementById("schema-breadcrumbs-jsonld")
            if (script) {
                script.remove()
            }
        }
    },
    mounted() {
        if (usePage().props.breadcrumbs) {
            this.breadcrumbs = usePage().props.breadcrumbs;
            this.insertSchemaMarkup()
        }
    },
    beforeUnmount() {
        this.removeSchemaMarkup()
    },
    setup() {
        const themeStore = useThemeStore();

        return {themeStore};
    },
};
</script>
